"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _CodeConsts = require("../../../constants/CodeConsts");
var _labelConsts = require("../../../constants/labelConsts");
var _CLabel = _interopRequireDefault(require("../../materials/CLabel"));
var _CTextField = _interopRequireDefault(require("../../materials/CTextField"));
var _InputFile = _interopRequireDefault(require("../../materials/InputFile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * アップロード入力部品
 */
const UploadInputParts = props => {
  const {
    intl,
    siteKindCd,
    documentKindCd,
    onChangeEntry,
    uploadEntry,
    onRef,
    fileError,
    fileHelperText,
    versionCntError,
    versionCntHelperText,
    noteError,
    noteHelperText
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_UPLOAD_FILE
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_InputFile.default, {
    onRef: onRef,
    onChange: onChangeEntry('uploadFile'),
    error: fileError,
    helperText: fileHelperText
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_FILE_SELECTION
  })))), siteKindCd !== _CodeConsts.CODE.SITE_KIND_CD.CODE_00 && documentKindCd !== 'ANK' && documentKindCd !== 'SUP' && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_EDITION_NUMBER
    }),
    hint: _labelConsts.LABEL.CORE_DOCUMENT_EDITION_NUMBER_MESSAGE,
    required: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: uploadEntry.versionCnt,
    onChange: onChangeEntry('versionCnt'),
    maxLength: 3,
    inputProps: {
      inputMode: 'numeric',
      pattern: '[0-9]*'
    },
    error: !!versionCntError,
    helperText: versionCntHelperText
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_DESCRIPTION
    })
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: uploadEntry.note,
    onChange: onChangeEntry('note'),
    maxLength: 30,
    multiline: true,
    rows: 2,
    error: !!noteError,
    helperText: noteHelperText
  }))));
};
UploadInputParts.propTypes = {
  siteKindCd: _propTypes.default.string.isRequired,
  documentKindCd: _propTypes.default.string.isRequired,
  onChangeEntry: _propTypes.default.func.isRequired,
  uploadEntry: _propTypes.default.object.isRequired,
  onRef: _propTypes.default.func,
  fileError: _propTypes.default.bool,
  fileHelperText: _propTypes.default.node,
  versionCntError: _propTypes.default.bool,
  versionCntHelperText: _propTypes.default.node,
  noteError: _propTypes.default.bool,
  noteHelperText: _propTypes.default.node
};
var _default = exports.default = (0, _reactIntl.injectIntl)(UploadInputParts);